<template lang="pug">

  div
    v-layout(align-center justify-space-between)
      div
        span(class="title") Franchises
        span(class="ml-3 grey--text subheading") Franchise
        span(class="ml-3 grey--text subheading") Subcontractor
        span(class="ml-3 grey--text subheading") Number of served sites
        span(class="ml-3 grey--text subheading") Number of jobs
        span(class="ml-3 grey--text subheading") Average job cost
        span(class="ml-3 grey--text subheading") Total cost of the jobs
        span(class="ml-3 grey--text subheading") Mean delivery
        span(class="ml-3 grey--text subheading") Rating
      v-btn(
        :disabled="loading || error"
        class="ma-0"
        icon
        @click="dialog = true")
        v-icon cloud_download
    v-progress-linear(
      v-if="loading"
      class="ma-0"
      color="grey"
      height="1"
      indeterminate)
    v-divider(v-else)

    v-dialog(v-model="dialog" max-width="40rem")
      v-card
        v-card-title
          span(class="headline") Choose a period
        v-card-actions
          v-layout(justify-space-around)
            v-btn(flat @click="download('week')") Week
            v-btn(flat @click="download('month')") Month
            v-btn(flat @click="download('year')") Year
            v-btn(flat @click="download('all')") All

    a(ref="anchor")

</template>

<script>
import Papa from "papaparse";
import moment from "moment";

export default {
  name: "franchises",
  data () {
    return {
      dialog: false,
      error: false,
      loading: false,
      report: {
        all: [],
        month: [],
        week: [],
        year: []
      }
    };
  },
  created () {
    this.loading = true;
    Promise.all([
      this.$http.get("/api/reports/franchises?period=week"),
      this.$http.get("/api/reports/franchises?period=month"),
      this.$http.get("/api/reports/franchises?period=year"),
      this.$http.get("/api/reports/franchises")
    ]).
      then(([week, month, year, all]) => {
        this.report.week = week.data;
        this.report.month = month.data;
        this.report.year = year.data;
        this.report.all = all.data;
      }).
      catch(() => this.error = true).
      finally(() => this.loading = false);
  },
  methods: {
    download (period) {
      const csv = Papa.unparse(this.report[period]);
      // Add a byte order mark (BOM: U+FEFF)
      const blob = new Blob(["\ufeff", csv]);
      var a = this.$refs.anchor;
      a.href = window.URL.createObjectURL(blob);
      a.download = `franchises_${period}_${moment().format("YYYYMMDD")}.csv`;
      a.click();
      this.dialog = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Reports/Franchises.vue